// @ts-nocheck

  import UserOutlined from '@ant-design/icons/es/icons/UserOutlined';
import SmileOutlined from '@ant-design/icons/es/icons/SmileOutlined';
import BugOutlined from '@ant-design/icons/es/icons/BugOutlined';
import PartitionOutlined from '@ant-design/icons/es/icons/PartitionOutlined'
  export default {
    UserOutlined,
SmileOutlined,
BugOutlined,
PartitionOutlined
  }